export default __webpack_public_path__ + "static/media/clockApp.86fad49d.png";